import React from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import { onHandNumberFormatWithoutDecimal } from '../../Services/formatting';
import onHandLowStock from '../../Services/onHandLowStock';
import StockNotifyButton from '../Stock/StockNotifyButton';
import { setNotifyEmailWhenInStock } from '../../Actions/Product.action';
import IncomingStock from './IncomingStock';

const StockCaseDisplay = ({ stockArticle, articleWeight, articleFactorKg, variantSystemId, isStandAlone }) => {
  const dispatch = useDispatch(),
    { quantity, inventoryUnit, isStockNotify, originWarehouse } = stockArticle,
    hasLowStock = onHandLowStock(inventoryUnit, articleFactorKg, quantity, articleWeight);

  const quantityDisplay = quantity > 10 ? onHandNumberFormatWithoutDecimal.format(quantity) : quantity;

  const renderLowStockAttention = () =>
    hasLowStock && (
      <svg className='stock-icon stock-icon--attention'>
        <use href='/ui/images/sprites/be-group.svg#attention'></use>
      </svg>
    );

  return (
    <>
      <div className={hasLowStock ? 'stock__attention' : ''}>
        {renderLowStockAttention()}
        {quantityDisplay} {translate('orderrow.' + inventoryUnit)}{' '}
        {quantity > 0 && originWarehouse}
      </div>
      {quantity > 0 ? (
        hasLowStock && (
          <p>{translate('orderrow.lowstock.notification')}</p>
        )
      ) : (
        <>
          <div>
            {articleWeight > 0 && translate('orderrow.lowstock.notification')}
          </div>
          {!isStandAlone && (
            <StockNotifyButton
              productId={variantSystemId}
              addStockNotify={(id) => dispatch(setNotifyEmailWhenInStock(id))}
              isStockNotify={isStockNotify}
            />
          )}
        </>
      )}
      <IncomingStock stockArticle={stockArticle} />
    </>
  );
};

export default StockCaseDisplay;
